import { components } from "react-select";
import Select from "react-select";
import React from "react";
import { CircularAvatar, DropDown } from "../../../commons";
import { SourcesDropDown } from "../../../../constant/hrms/recruitmentModule/recruitmentTrackerDropdown";
type AppProps = {
  OtherDetails: any;
  inputDetailsError: any;
  handleBasicDetailsInput: (data: any, section: string, name: string) => void;
  finalReferedByList: any;
  userFetching: boolean;
  referedByText: string;
  referedByOffset: number;
  setReferedByOffset: React.Dispatch<React.SetStateAction<number>>;
  setReferedByText: React.Dispatch<React.SetStateAction<string>>;
  referedByLimit: number;
  handleReferedByDropdownChange: (data: any) => void;
  handleSourcesChange: (data: any) => void;
};

const OtherDetails = ({
  OtherDetails,
  inputDetailsError,
  handleBasicDetailsInput,
  finalReferedByList,

  userFetching,
  referedByText,

  referedByOffset,
  setReferedByText,
  setReferedByOffset,
  referedByLimit,
  handleReferedByDropdownChange,
  handleSourcesChange,
}: AppProps) => {
  const checkBottom = (e: any) => {
    setReferedByOffset((prv: any) => prv + referedByLimit);
  };
  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };
  const dropDownStyle = {
    option: (baseStyles: any, state: any) => ({
      ...baseStyles,
      width: "300px",
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      width: "77%",
    }),
    container: (provided: any) => ({
      ...provided,
      width: 320,
      position: "absolute",
    }),
  };
  return (
    <>
      <div className="mb-2" style={{ marginTop: "29px" }}>
        <h5
          style={{ marginBottom: "10px", fontSize: "15px", fontWeight: "600" }}
        >
          OTHER DETAILS
        </h5>
      </div>
      <div className="row" style={{ marginBottom: "20px" }}>
        <div className="col-md-3">
          <label className="mb-1" htmlFor="firstName">
            Referred By
          </label>
          <div>
            <Select
              options={finalReferedByList}
              value={OtherDetails?.referredBy}
              components={{ Option }}
              onChange={(e) => handleReferedByDropdownChange(e)}
              isSearchable={true}
              isLoading={userFetching && referedByText?.length > 0}
              onMenuClose={() => {
                setReferedByOffset(0);
              }}
              onMenuScrollToBottom={(e: any) => checkBottom(e)}
              // isDisabled={isDisabled}
              onInputChange={(e) => {
                setReferedByText(e);
              }}
            />
            {!!inputDetailsError?.currentTotalCtcError && (
              <small className="text-danger">
                {inputDetailsError?.currentTotalCtcError}
              </small>
            )}
          </div>
        </div>
        {
          <>
            <div className="col-md-3">
              <label className="mb-1" htmlFor="firstName">
                Source
              </label>
              <div>
                <DropDown
                  options={SourcesDropDown}
                  value={OtherDetails?.sources}
                  handleChange={handleSourcesChange}
                  //  disabled={isDisabled}
                />
              </div>
            </div>
            <div className="col-md-3">
              <label className="mb-1" htmlFor="lastName">
                Meeting Link
              </label>
              <div>
                <input
                  type="text"
                  className={`form-control ${
                    inputDetailsError?.meetingLinkError ? "error-border" : ""
                  }`}
                  name="meetingLink"
                  onChange={(e) =>
                    handleBasicDetailsInput(e, "otherDetails", "meetingLink")
                  }
                  value={OtherDetails?.meetingLink}
                  // disabled={isDisabled}
                />
                {/* {!!inputDetailsError?.meetingLinkError && (
                  <small className="text-danger">
                    {inputDetailsError?.meetingLinkError}
                  </small>
                )} */}
              </div>
            </div>
          </>
        }
      </div>
    </>
  );
};

export default OtherDetails;
